import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackbarData } from '../../_models/snackbar-data.model';
import { InlineSnackbar } from '../inline-snackbar/inline-snackbar';

@Component({
  selector: 'app-custom-snackbar',
  imports: [InlineSnackbar],
  templateUrl: './custom-snackbar.html',
  styleUrl: './custom-snackbar.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomSnackbar {
  public snackBarRef = inject(MatSnackBarRef<CustomSnackbar>);
  public snackbarData: SnackbarData = inject(MAT_SNACK_BAR_DATA);

  public dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
